import React, { useState, useEffect, useRef, useMemo } from "react";
import uparrow from "../../images/Vectoruparrow.png";
import downarrow from "../../images/Vectordownarrow.png";

const NationalityDropdown = ({ title,nationalitydata, selectedNationality, onSelect }) => {
  const [search, setSearch] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [selected_value, setselected_value] = useState('');
  const dropdownRef = useRef(null);

  // Sync input field with selectedNationality label when it changes
  useEffect(() => {
    const match = nationalitydata.find(nation => nation.value == selectedNationality);
    setSearch(match ? match.label : "");
  }, [selectedNationality, nationalitydata]);

  // Filtered dropdown options based on search
  const filteredList = useMemo(() => {
    return nationalitydata?.filter(nation =>
      nation.label.toLowerCase().includes(search.toLowerCase())
    );
  }, [search, nationalitydata]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Handle input change
  const handleChange = (e) => {
    const value = e.target.value;
    setSearch(value);
    setselected_value('')

    const exactMatch = nationalitydata.find(
      nation => nation.label.toLowerCase() === value.toLowerCase()
    );

    if (exactMatch) {
      onSelect(exactMatch.value);
      setShowDropdown(false);
    } else {
      onSelect(""); // Clear selection if no exact match
      setShowDropdown(true); // Show dropdown for fuzzy search
    }
  };

  // Handle item selection from dropdown
  const handleSelect = (value) => {
    const match = nationalitydata.find(nation => nation.value === value);
    setselected_value(match.label)
    if (match) {
      setSearch(match.label);
      onSelect(value);
      setShowDropdown(false);
    }
  };

  return (
    <div className="inputbox-margin">
        {
            title &&
            <div className="inputbox-title">{title}</div>
        }
 
    <div ref={dropdownRef} className="nationality-dropdown ">
   
      <input
        type="text"
        placeholder="Search Nationality"
        value={selected_value != '' ? selected_value : search}
        onChange={handleChange}
        onFocus={() => {
          setSearch('')
          setShowDropdown(true)
        }}
        className="forminputbox"
      />
      <div className="up-downarrow">
        {showDropdown ? (
          <img
            src={uparrow}
            alt="up"
            onClick={() => setShowDropdown(false)}
            style={{ cursor: "pointer" }}
          />
        ) : (
          <img
            src={downarrow}
            alt="down"
            onClick={() => {
              setSearch('')
              setShowDropdown(true)
            }}
            style={{ cursor: "pointer" }}
          />
        )}
      </div>

      {showDropdown && (
        <div className="dropdown-options p-2">
          {filteredList.length > 0 ? (
            filteredList.map((nation) => (
              <div
                key={nation.value}
                className={`dropdown-option subcategory-item ${nation.label == selected_value && 'active_search_Selected_item'}`}
                onClick={() => handleSelect(nation.value)}
              >
                {nation.label}
              </div>
            ))
          ) : (
            <div className="dropdown-option">No results found</div>
          )}
        </div>
      )}
    </div>
    </div>
  );
};

export default NationalityDropdown;
